(function installAdornCouponCopy() {
  if (window.__adornCouponCopyV4) return;
  window.__adornCouponCopyV4 = true;
  const timers = new WeakMap();
  document.addEventListener('click', async event => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-adorn-copy-offer]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    if (button.getAttribute('aria-busy') === 'true') return;
    const code = button.dataset.code || 'FEST7';
    const label = button.querySelector('[data-adorn-offer-code]');
    const status = button.querySelector('[data-adorn-copy-status]');
    button.setAttribute('aria-busy', 'true');
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(code);
      } else {
        const field = document.createElement('textarea');
        field.value = code;
        field.readOnly = true;
        field.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;opacity:0;font-size:16px';
        // Keep the fallback inside a modal dialog's focus scope.
        (button.closest('dialog') || document.body).appendChild(field);
        field.select();
        field.setSelectionRange(0, code.length);
        let copied = false;
        try { copied = document.execCommand('copy'); } finally { field.remove(); }
        button.focus({ preventScroll: true });
        if (!copied) throw new Error('Clipboard permission unavailable');
      }
      clearTimeout(timers.get(button));
      button.classList.add('is-copied');
      if (label) label.textContent = 'COPIED';
      if (status) status.textContent = code + ' copied. Apply it at checkout.';
      timers.set(button, setTimeout(() => {
        button.classList.remove('is-copied');
        if (label) label.textContent = code;
        if (status) status.textContent = '';
      }, 1600));
    } catch (error) {
      if (label) label.textContent = code;
      if (status) status.textContent = 'Copy was blocked. Please type ' + code + ' at checkout.';
      button.title = 'Copy blocked. Please type ' + code + ' at checkout.';
    } finally {
      button.removeAttribute('aria-busy');
    }
  }, true);
})();/* Adorn collection Quick View V4 — pairs with card-product.liquid templates.
 * No global.js replacement, synthetic opener.click(), per-card modal startup,
 * full-document focus/media scan, or repeated DOM observer is used here.
 */
(() => {
  'use strict';
  if (window.__adornQuickViewV4) return;
  window.__adornQuickViewV4 = true;

  const cache = new Map();
  const CACHE_TTL = 120000;
  const MAX_CACHE = 32;
  const widths = [360, 540, 720, 900, 1100];
  const imageSizes = '(max-width: 749px) calc(100vw - 40px), (max-width: 1200px) 50vw, 590px';
  const swatchSelector = '[data-adorn-card-colour-popup], [data-adorn-qv-colour-option]';
  let active = null;
  let prefetchTimer = 0;

  function productURL(value) {
    const url = new URL(value, location.origin);
    if (url.origin !== location.origin || !url.pathname.includes('/products/')) {
      throw new Error('Invalid storefront product URL');
    }
    url.hash = '';
    return url;
  }

  function jsonURL(value) {
    const url = productURL(value);
    url.search = '';
    url.pathname = url.pathname.replace(/\/$/, '').replace(/\.js$/, '') + '.js';
    return url.href;
  }

  function fetchProduct(value) {
    let key;
    try { key = jsonURL(value); } catch (error) { return Promise.reject(error); }
    const cached = cache.get(key);
    if (cached && Date.now() - cached.time < CACHE_TTL) return cached.promise;
    cache.delete(key);
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 12000);
    const entry = { time: Date.now(), promise: null };
    entry.promise = fetch(key, {
      credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: controller.signal
    }).then(response => {
      if (!response.ok) throw new Error('Product request failed (' + response.status + ')');
      return response.json();
    }).then(product => {
      if (!product || !Array.isArray(product.variants)) throw new Error('Invalid product data');
      return product;
    }).catch(error => {
      if (cache.get(key) === entry) cache.delete(key);
      throw error;
    }).finally(() => clearTimeout(timeout));
    cache.set(key, entry);
    while (cache.size > MAX_CACHE) cache.delete(cache.keys().next().value);
    return entry.promise;
  }

  function imageURL(value, width) {
    const src = typeof value === 'object' && value ? value.src || value.url : value;
    if (typeof src !== 'string' || !src) return '';
    try {
      const url = new URL(src.startsWith('//') ? 'https:' + src : src, location.origin);
      if (!['https:', 'http:'].includes(url.protocol)) return '';
      // Width transforms are only applied to Shopify CDN images.
      if (url.hostname === 'cdn.shopify.com' || (url.origin === location.origin && url.pathname.includes('/cdn/shop/'))) {
        url.searchParams.set('width', String(width));
        url.searchParams.delete('height');
      }
      return url.href;
    } catch (_) { return ''; }
  }

  function imagesFor(product) {
    const images = (Array.isArray(product.images) ? product.images : [])
      .map(src => imageURL(src, 1100)).filter(Boolean);
    if (!images.length && product.featured_image) images.push(imageURL(product.featured_image, 1100));
    return Array.from(new Set(images.filter(Boolean))).slice(0, 10);
  }

  function writeText(element, value) {
    if (element && element.textContent !== String(value)) element.textContent = String(value);
  }

  function setMessage(state, message) {
    writeText(state.message, message);
  }

  function formatMoney(state, cents) {
    const amount = Number(cents || 0) / 100;
    return new Intl.NumberFormat('en-IN', {
      style: 'currency', currency: state.currency,
      minimumFractionDigits: Number.isInteger(amount) ? 0 : 2, maximumFractionDigits: 2
    }).format(amount);
  }

  function variantFor(product, url) {
    const variants = product.variants;
    const wanted = productURL(url).searchParams.get('variant');
    return (wanted && variants.find(variant => String(variant.id) === wanted)) ||
      variants.find(variant => variant.available) || variants[0] || null;
  }

  function mainImage(state, index) {
    if (!state.images.length) return;
    index = (index + state.images.length) % state.images.length;
    state.index = index;
    const src = state.images[index];
    if (state.main) {
      state.main.sizes = imageSizes;
      state.main.srcset = widths.map(width => imageURL(src, width) + ' ' + width + 'w').join(', ');
      state.main.src = imageURL(src, 720);
      state.main.alt = state.title;
    }
    state.thumbs.querySelectorAll('[data-adorn-qv-thumb]').forEach((button, i) => {
      button.classList.toggle('is-active', i === index);
      button.setAttribute('aria-pressed', String(i === index));
    });
    writeText(state.counter, (index + 1) + ' / ' + state.images.length);
  }

  function gallery(state, images, title) {
    state.images = images;
    state.title = title;
    if (!state.main && images.length) {
      const media = state.dialog.querySelector('.adorn-qv__main-media');
      if (media) {
        state.main = document.createElement('img');
        state.main.className = 'adorn-qv__main-image';
        state.main.setAttribute('data-adorn-qv-main-image', '');
        state.main.width = 1100;
        state.main.height = 1100;
        state.main.decoding = 'async';
        media.appendChild(state.main);
      }
    }
    const fragment = document.createDocumentFragment();
    images.forEach((src, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'adorn-qv__thumb';
      button.setAttribute('data-adorn-qv-thumb', '');
      button.dataset.imageSrc = src;
      button.setAttribute('aria-label', 'View image ' + (index + 1));
      const image = document.createElement('img');
      image.src = imageURL(src, 120);
      image.width = 54;
      image.height = 54;
      image.alt = '';
      image.loading = 'lazy';
      image.decoding = 'async';
      button.appendChild(image);
      fragment.appendChild(button);
    });
    state.thumbs.replaceChildren(fragment);
    if (images.length) mainImage(state, 0);
    else {
      state.index = 0;
      if (state.main) { state.main.removeAttribute('srcset'); state.main.removeAttribute('src'); }
      writeText(state.counter, '');
    }
    state.dialog.querySelectorAll('[data-adorn-qv-prev], [data-adorn-qv-next]').forEach(button => {
      button.disabled = images.length < 2;
    });
  }

  function loading(state, pending) {
    state.busy = pending;
    state.dialog.setAttribute('aria-busy', String(pending));
    if (state.loader) state.loader.hidden = !pending;
    if (state.add) state.add.disabled = pending || !state.canAdd;
    if (!pending) state.dialog.querySelectorAll('.is-pending').forEach(button => button.classList.remove('is-pending'));
  }

  function updateProduct(state, product, button) {
    const variant = variantFor(product, button.dataset.productUrl);
    const price = Number(variant ? variant.price : product.price || 0);
    const compare = Number(variant ? variant.compare_at_price || 0 : product.compare_at_price || 0);
    const discount = compare > price && compare > 0 ? Math.round((compare - price) * 100 / compare) : 0;
    const dialog = state.dialog;
    const title = product.title || '';
    dialog.querySelectorAll('[data-adorn-qv-title]').forEach(el => writeText(el, title));
    dialog.setAttribute('aria-label', 'Quick view ' + title);
    writeText(dialog.querySelector('[data-adorn-qv-selected-color]'), button.dataset.colour || '');
    dialog.querySelectorAll('[data-adorn-qv-colour-option]').forEach(item => {
      const chosen = item === button;
      item.classList.toggle('is-active', chosen);
      item.setAttribute('aria-pressed', String(chosen));
    });
    dialog.querySelectorAll('[data-adorn-qv-discount-badge]').forEach(el => {
      el.hidden = discount <= 0; writeText(el, discount + '% off');
    });
    const tag = Array.isArray(product.tags) ? product.tags.find(t => /limited time deal/i.test(t)) : '';
    const deal = button.dataset.dealLabel || tag || '';
    dialog.querySelectorAll('[data-adorn-qv-deal-label]').forEach(el => { el.hidden = !deal; writeText(el, deal); });
    const discountEl = dialog.querySelector('[data-adorn-qv-discount]');
    if (discountEl) { discountEl.hidden = discount <= 0; writeText(discountEl, '-' + discount + '%'); }
    writeText(dialog.querySelector('[data-adorn-qv-price]'), formatMoney(state, price));
    const mrp = dialog.querySelector('[data-adorn-qv-mrp-row]');
    if (mrp) mrp.hidden = !(compare > price);
    writeText(dialog.querySelector('[data-adorn-qv-compare-price]'), formatMoney(state, compare));

    // Do not leave the PREVIOUS product's rating on a newly selected product.
    const rating = Number(button.dataset.rating || 0);
    dialog.querySelectorAll('.adorn-qv__rating').forEach(row => {
      // Keep the existing rating slot's height when a colour has no rating.
      row.hidden = false;
      row.style.visibility = rating ? 'visible' : 'hidden';
      row.setAttribute('aria-hidden', String(!rating));
      writeText(row.querySelector('.adorn-card-rating__value'), rating ? String(Math.round(rating * 10) / 10) : '');
      const stars = row.querySelector('.adorn-card-rating__stars');
      if (stars) stars.style.setProperty('--adorn-rating-percent', Math.min(rating, 5) * 20 + '%');
      writeText(row.querySelector('.adorn-card-rating__count'), button.dataset.ratingCount || '');
    });

    const input = dialog.querySelector('[data-adorn-qv-variant-id]');
    if (input) input.value = variant ? String(variant.id) : '';
    const quantity = dialog.querySelector('.adorn-qv__form [name="quantity"]');
    if (quantity) quantity.value = String(variant && variant.quantity_rule && variant.quantity_rule.min || 1);
    state.canAdd = Boolean(variant && variant.available && !product.requires_selling_plan);
    if (state.add) writeText(state.add, product.requires_selling_plan ? 'Select options on product page' : state.canAdd ? 'Add to cart' : 'Sold out');
    const link = dialog.querySelector('[data-adorn-qv-product-link]');
    if (link) link.href = productURL(button.dataset.productUrl).href;
    state.productUrl = button.dataset.productUrl;
    dialog.dataset.productUrl = state.productUrl;
    const delivery = dialog.querySelector('[data-adorn-qv-delivery]');
    if (delivery) {
      delivery.dataset.shipsIn = button.dataset.shipsIn || '';
      if (window.AdornDeliveryEngine && typeof window.AdornDeliveryEngine.updateElement === 'function') {
        window.AdornDeliveryEngine.updateElement(delivery);
      }
    }
    gallery(state, imagesFor(product), title);
  }

  async function selectColour(state, button) {
    if (!state || !button || !button.dataset.productUrl) return;
    const request = ++state.request;
    if (button.dataset.productUrl === state.productUrl) {
      loading(state, false);
      setMessage(state, '');
      return;
    }
    state.dialog.querySelectorAll('.is-pending').forEach(item => item.classList.remove('is-pending'));
    button.classList.add('is-pending');
    loading(state, true);
    setMessage(state, '');
    try {
      const product = await fetchProduct(button.dataset.productUrl);
      if (active !== state || request !== state.request || !state.dialog.open) return;
      updateProduct(state, product, button);
    } catch (error) {
      if (active === state && request === state.request) {
        setMessage(state, 'That colour could not be loaded. Please try again or open the product page.');
        console.warn('[Adorn Quick View]', error.message);
      }
    } finally {
      if (active === state && request === state.request) loading(state, false);
    }
  }

  function lockScroll(state) {
    const root = document.documentElement;
    state.scrollStyle = { overflow: root.style.overflow, paddingRight: root.style.paddingRight };
    // Read once, before any writes. Modern browsers use the pre-reserved CSS gutter.
    const gap = Math.max(0, window.innerWidth - root.clientWidth);
    if (!CSS.supports('scrollbar-gutter: stable') && gap) {
      const padding = parseFloat(getComputedStyle(root).paddingRight) || 0;
      root.style.paddingRight = padding + gap + 'px';
    }
    root.style.overflow = 'hidden';
  }

  function closeQuickView(restoreFocus = true) {
    const state = active;
    if (!state) return;
    active = null;
    state.request += 1;
    if (state.dialog.open) state.dialog.close();
    state.dialog.remove();
    const root = document.documentElement;
    root.style.overflow = state.scrollStyle.overflow;
    root.style.paddingRight = state.scrollStyle.paddingRight;
    if (restoreFocus && state.opener && state.opener.isConnected) state.opener.focus({ preventScroll: true });
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
  }

  function openQuickView(trigger, desiredURL) {
    const card = trigger.closest('.adorn-collection-card');
    const template = card && card.querySelector('template[data-adorn-qv-template]');
    const fallbackURL = desiredURL || card && card.dataset.productUrl;
    // No script-loaded shell? Keep product access working instead of a dead eye icon.
    if (!template || typeof HTMLDialogElement === 'undefined' || !HTMLDialogElement.prototype.showModal) {
      if (fallbackURL) location.assign(productURL(fallbackURL).href);
      return;
    }
    closeQuickView(false);
    const fragment = template.content.cloneNode(true);
    const dialog = fragment.querySelector('dialog[data-adorn-qv-modal]');
    if (!dialog) return;
    document.body.appendChild(dialog);
    const state = {
      dialog, opener: trigger, request: 0, busy: false,
      productUrl: dialog.dataset.productUrl, currency: dialog.dataset.currency || 'INR',
      main: dialog.querySelector('[data-adorn-qv-main-image]'),
      thumbs: dialog.querySelector('[data-adorn-qv-thumbs]'),
      counter: dialog.querySelector('[data-adorn-qv-gallery-counter]'),
      message: dialog.querySelector('[data-adorn-qv-message]'),
      loader: dialog.querySelector('[data-adorn-qv-loading]'),
      add: dialog.querySelector('[data-adorn-qv-add-button]'),
      title: dialog.querySelector('[data-adorn-qv-title]')?.textContent || '',
      images: [], index: 0
    };
    state.canAdd = state.add && !state.add.disabled;
    state.images = Array.from(state.thumbs.querySelectorAll('[data-adorn-qv-thumb]'), button => button.dataset.imageSrc).filter(Boolean);
    active = state;
    lockScroll(state);
    dialog.addEventListener('cancel', event => { event.preventDefault(); closeQuickView(); });
    dialog.addEventListener('close', () => { if (active === state) closeQuickView(); });
    dialog.addEventListener('submit', event => {
      if (state.busy || !state.canAdd) { event.preventDefault(); return; }
      // Preserve the theme's native Shopify form action; no duplicate AJAX cart write.
    });
    dialog.showModal();
    const close = dialog.querySelector('[data-adorn-qv-close]');
    if (close) close.focus({ preventScroll: true });
    const delivery = dialog.querySelector('[data-adorn-qv-delivery]');
    if (delivery && window.AdornDeliveryEngine) window.AdornDeliveryEngine.updateElement(delivery);
    writeText(state.counter, state.images.length ? '1 / ' + state.images.length : '');
    if (desiredURL) {
      const button = Array.from(dialog.querySelectorAll('[data-adorn-qv-colour-option]'))
        .find(item => item.dataset.productUrl === desiredURL);
      if (button) selectColour(state, button);
    }
  }

  // One delegated click path survives Shopify collection filtering/pagination.
  window.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const target = event.target;
    if (target.closest('[data-adorn-copy-offer]')) return; // shared clipboard controller handles it
    const cardColour = target.closest('[data-adorn-card-colour-popup]');
    const eye = target.closest('[data-adorn-qv-open], .adorn-card-view-opener .adorn-card-view-icon');
    if (cardColour || eye) {
      event.preventDefault(); event.stopImmediatePropagation();
      openQuickView(cardColour || eye, cardColour ? cardColour.dataset.productUrl : null);
      return;
    }
    if (!active || !active.dialog.contains(target)) return;
    const deliveryTrigger = target.closest('[data-adorn-qv-delivery]');
    if (deliveryTrigger) {
      // The existing pincode popup is outside the native dialog's top layer.
      // Close Quick View first, then open that popup; do not leave it inert.
      event.preventDefault(); event.stopImmediatePropagation();
      closeQuickView(false);
      if (window.AdornDeliveryEngine && typeof window.AdornDeliveryEngine.openPincodePopup === 'function') {
        window.AdornDeliveryEngine.openPincodePopup();
      } else window.dispatchEvent(new CustomEvent('adorn:open-pincode-selector'));
      return;
    }
    if (target === active.dialog || target.closest('[data-adorn-qv-close]')) {
      event.preventDefault(); event.stopImmediatePropagation(); closeQuickView(); return;
    }
    const colour = target.closest('[data-adorn-qv-colour-option]');
    if (colour) {
      event.preventDefault(); event.stopImmediatePropagation(); selectColour(active, colour); return;
    }
    const thumb = target.closest('[data-adorn-qv-thumb]');
    const previous = target.closest('[data-adorn-qv-prev]');
    const next = target.closest('[data-adorn-qv-next]');
    if (thumb || previous || next) {
      event.preventDefault(); event.stopImmediatePropagation();
      if (thumb) {
        const index = Array.from(active.thumbs.children).indexOf(thumb);
        if (index >= 0) mainImage(active, index);
      } else mainImage(active, active.index + (next ? 1 : -1));
    }
  }, true);

  window.addEventListener('keydown', event => {
    if (!active || !['Enter', ' '].includes(event.key) || !(event.target instanceof Element)) return;
    const delivery = event.target.closest('[data-adorn-qv-delivery]');
    if (delivery && active.dialog.contains(delivery)) {
      event.preventDefault();
      delivery.click();
    }
  }, true);

  // A single intentional desktop hover may prefetch one JSON request. Never
  // prefetch every product or start speculative traffic on touch/Save-Data.
  document.addEventListener('pointerover', event => {
    if (event.pointerType !== 'mouse' || !(event.target instanceof Element)) return;
    const connection = navigator.connection;
    if (connection && (connection.saveData || /(^|-)2g|3g/.test(connection.effectiveType || ''))) return;
    const button = event.target.closest(swatchSelector);
    if (!button || !button.dataset.productUrl || (event.relatedTarget instanceof Node && button.contains(event.relatedTarget))) return;
    clearTimeout(prefetchTimer);
    prefetchTimer = setTimeout(() => {
      if (button.isConnected) fetchProduct(button.dataset.productUrl).catch(() => {});
    }, 150);
  }, { passive: true });
  document.addEventListener('pointerout', event => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest(swatchSelector);
    if (button && !(event.relatedTarget instanceof Node && button.contains(event.relatedTarget))) clearTimeout(prefetchTimer);
  }, { passive: true });
  window.addEventListener('pagehide', () => closeQuickView(false));
  document.addEventListener('shopify:section:unload', event => {
    if (active && event.target.contains(active.opener)) closeQuickView(false);
  });
})();
